// extracted by mini-css-extract-plugin
module.exports = {"menu":"_3k9Q7Vy-FyWFUPOIwt7IHK","item":"t4mD6rnAjN8D7iSKJAq5s","gray":"_1YVLuYxW3WCZhZx-4V4n_r"};